export default "/images/ja.png?3103647cc274f044866ac1ee65aa5d9b";